import styled from 'styled-components'

export const Ul = styled.ul`
  margin-left: 16px;

  list-style: square;
`
